import UsageChangeIcon from '@acorn-portal/shared/src/assets/shared/icons/base/car-shield-tick.svg?react';
import useReferenceData from '@acorn-portal/shared/src/hooks/useReferenceData';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { ListNames } from '@acorn-portal/shared/src/store/referenceData.slice';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface IUsageAndMileage {
	vehicleUse: string;
	businessMileage?: number;
	annualMileage: number;
	vehicleCover?: string;
	product: Product;
	licencingAuthority?: string;
	operatingArea?: string;
}

const UsageAndMileage: FC<IUsageAndMileage> = ({
	vehicleUse,
	vehicleCover,
	annualMileage,
	businessMileage,
	product,
	licencingAuthority,
	operatingArea,
}) => {
	const { getReferenceDataValue } = useReferenceData();

	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>
					<UsageChangeIcon />
				</Box>
				<Box>
					{vehicleCover && (
						<Typography data-testid='level-of-cover-milage'>
							{getReferenceDataValue(ListNames.levelOfCoverTypes, vehicleCover)}
						</Typography>
					)}
					<Typography data-testid='vehicle-usage-mileage'>
						{getReferenceDataValue(ListNames.vehicleUseOptions, vehicleUse)}
					</Typography>
					{product != Product.TAXI && (
						<>
							<Typography>Annual Mileage: {annualMileage}</Typography>
							{!!businessMileage && businessMileage > 0 && <Typography>Business Mileage: {businessMileage}</Typography>}
						</>
					)}
					{licencingAuthority && product == Product.TAXI && (
						<Typography>
							Licensing Authority: {getReferenceDataValue(ListNames.licencingArea, licencingAuthority)}{' '}
						</Typography>
					)}
					{operatingArea && product == Product.TAXI && (
						<Typography>
							Primary Operating Area: {getReferenceDataValue(ListNames.licencingArea, operatingArea)}{' '}
						</Typography>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default UsageAndMileage;
